var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-it"},_vm._l(((_vm.field.props.metrics || [])),function(metric){return _c('div',{key:metric.id,class:'field-it-metric' + (_vm.short ? ' field-it-short' : '' )},[_c('label',[_vm._v(_vm._s(metric.name))]),(_vm.field.value)?_c('span',[_vm._v(_vm._s(_vm.field.value[metric.id]))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }